import { useDispatch } from 'react-redux';
import { ArrangeFormItem } from '../../../utils/model/Arrange';
import { getParsedSelectedItems, LIST_VALUE_PROP_NAME, normalizeFilters } from '../../../utils/arranges-helpers';
import { applyProductArrangesRequest, removeProductFiltersRequest } from '../../../../../../../lib/store/slices/productsSlice';

export function useProductArrangeRequests({
  arrangedId,
  sortFieldName,
  clearFilters,
  setFilterLabel,
  getFilters,
  getFilterLabel,
  form,
  withSorting = true,
}) {
  const dispatch = useDispatch();

  const getSortOrder = () => form.getFieldValue(ArrangeFormItem.SORT_ORDER);
  const getSortField = () => ({ sortOrder: getSortOrder(), withSorting: true, sortFieldName });

  const getSorting = () => {
    const baseFields = { withSorting: false };
    return withSorting ? Object.assign(baseFields, getSortField()) : baseFields;
  };

  const getFiltering = () => {
    return getFilters ? normalizeFilters(getFilters()) : {};
  };

  const applyArranges = async () => {
    await dispatch(
      applyProductArrangesRequest({
        sorting: getSorting(),
        filtering: getFiltering(),
        activeArrangedId: arrangedId,
      })
    );

    if (setFilterLabel) {
      setFilterLabel(getFilterLabel);
    }
  };

  const removeFilter = async () => {
    clearFilters();
    await dispatch(removeProductFiltersRequest());
    setFilterLabel(null);
  };

  const removeFilterValue = async value => {
    const parsedItems = getParsedSelectedItems(form);
    const filteredItems = parsedItems.filter(item => item[LIST_VALUE_PROP_NAME] !== value);
    const stringifiedItems = filteredItems.map(JSON.stringify);
    form.setFieldValue(ArrangeFormItem.SELECTED_ITEMS, stringifiedItems);

    await dispatch(
      applyProductArrangesRequest({
        sorting: getSorting(),
        filtering: normalizeFilters(getFilters()),
        activeArrangedId: arrangedId,
      })
    );

    const filterLabel = getFilterLabel();
    setFilterLabel(filterLabel);

    if (!filterLabel) {
      clearFilters();
    }
  };

  return { applyArranges, removeFilter, removeFilterValue };
}
